import { gate as hubHttpGate } from 'hub-http/gates';
// TODO: Remove userInfoSync and replace with getGates, getScopes once the library has been converted to Quartz
import { userInfoSync } from 'hub-http/userInfo';
// import { getGates, getScopes } from 'quartz-core/framework/auth/app';

// TODO: Remove this stopgap function once the library has been converted to Quartz
function getGates() {
  const {
    gates
  } = userInfoSync();
  return new Set(gates);
}

// TODO: Remove this stopgap function once the library has been converted to Quartz
function getScopes() {
  const {
    user: {
      scopes
    }
  } = userInfoSync();
  return new Set(scopes);
}
export function hasAssetGateAccess(associationSettings, objectType) {
  var _associationSettings$, _associationSettings$2;
  const gates = getGates();
  return (_associationSettings$ = (_associationSettings$2 = associationSettings[objectType].campaignsAssociations) === null || _associationSettings$2 === void 0 || (_associationSettings$2 = _associationSettings$2.metadata) === null || _associationSettings$2 === void 0 || (_associationSettings$2 = _associationSettings$2.requiredGates) === null || _associationSettings$2 === void 0 ? void 0 : _associationSettings$2.value.every(gate =>
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  gates.has(gate) || gates.has(hubHttpGate(gate)))) !== null && _associationSettings$ !== void 0 ? _associationSettings$ : true;
}
export function hasAssetPortalScopeAccess(associationSettings, objectType) {
  var _associationSettings$3, _associationSettings$4;
  const scopes = getScopes();
  return (_associationSettings$3 = (_associationSettings$4 = associationSettings[objectType].campaignsAssociations) === null || _associationSettings$4 === void 0 || (_associationSettings$4 = _associationSettings$4.metadata.requiredPortalScopes) === null || _associationSettings$4 === void 0 ? void 0 : _associationSettings$4.value.every(scope => scopes.has(scope))) !== null && _associationSettings$3 !== void 0 ? _associationSettings$3 : true;
}
export function hasAssetAccess(associationSettings, objectType) {
  return hasAssetGateAccess(associationSettings, objectType) && hasAssetPortalScopeAccess(associationSettings, objectType);
}
export function hasAssetReadAccess(associationSettings, objectType) {
  var _associationSettings$5;
  const scopes = getScopes();
  const userReadScope = (_associationSettings$5 = associationSettings[objectType].campaignsAssociations) === null || _associationSettings$5 === void 0 || (_associationSettings$5 = _associationSettings$5.metadata) === null || _associationSettings$5 === void 0 ? void 0 : _associationSettings$5.userReadScope;
  const hasReadAccess = userReadScope !== null && userReadScope !== void 0 && userReadScope.value ? scopes.has(userReadScope.value) : true;
  return hasReadAccess;
}
export function hasAssetWriteAccess(associationSettings, objectType) {
  var _associationSettings$6;
  const scopes = getScopes();
  const userWriteScope = (_associationSettings$6 = associationSettings[objectType].campaignsAssociations) === null || _associationSettings$6 === void 0 || (_associationSettings$6 = _associationSettings$6.metadata) === null || _associationSettings$6 === void 0 ? void 0 : _associationSettings$6.userWriteScope;
  const hasWriteAccess = userWriteScope !== null && userWriteScope !== void 0 && userWriteScope.value ? scopes.has(userWriteScope.value) : true;
  return hasWriteAccess;
}